var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-resources-summary" }, [
    _vm.summaryHeading
      ? _c("h2", { staticClass: "c-resources-summary__heading" }, [
          _vm._v("\n    " + _vm._s(_vm.summaryHeading) + "\n    "),
          _c("small", [
            _vm._v(
              _vm._s(
                _vm.requestedItems.length > 0
                  ? "(" + _vm.requestedItems.length + ")"
                  : null
              )
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-resources-summary__list" },
      _vm._l(_vm.requestedItems, function(item) {
        return _c("div", { key: item.id, staticClass: "c-resource-item" }, [
          _c("p", { staticClass: "c-resource-item__info" }, [
            _c("span", { staticClass: "c-resource-item__title" }, [
              _vm._v(_vm._s(item.name))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "c-resource-item__label" }, [
              _vm._v(_vm._s(item.label))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-resource-item__actions" }, [
            _c("input", {
              staticClass: "c-resource-item__quantity",
              attrs: { type: "number" },
              domProps: { value: item.quantity },
              on: {
                change: function($event) {
                  return _vm.updateQuantity($event, item.id)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "c-resource-item__remove",
                on: {
                  click: function($event) {
                    return _vm.removeItem($event, item.id)
                  }
                }
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "c-resource-item__remove-icon",
                    attrs: { focusable: "false", "aria-hidden": "true" }
                  },
                  [_c("use", { attrs: { "xlink:href": "#bin" } })]
                )
              ]
            )
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5733a24d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5733a24d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/geneco/resources/form/ResourcesSummary.vue
// module id = 571
// module chunks = 0